import Aos from 'aos';
import React, { useEffect, useState } from 'react'
import { Commodities, Footer, Header, Loader } from '../components';




// GETTING RANDOM IMAGES OF SERVICES DATA
const fetchServiceData = async () => {
  const localImages = [
    '/3.jpg',
    '/4.jpg',
    '/5.jpg',
    '/6.jpg',
    '/pexels-500photos-com-15338-93400.jpg',
    '/pexels-asphotograpy-224924.jpg',
    '/pexels-daniel-12255.jpg',
    '/pexels-davidmcbee-392031.jpg',
    '/pexels-pixabay-162639.jpg',
    '/pexels-pixabay-236698.jpg',
    '/pexels-rezwan-1078884.jpg',
    '/pexels-rezwan-1116035.jpg',
    '/pexels-yury-kim-181374-585419.jpg',
    '/pexels-ywanphoto-188679.jpg'
  ];

  
  // fetching the random images
  const getRandomImage = () => localImages[Math.floor(Math.random() * localImages.length)];
  
  
  const servicesData = [
    {
      id: 1,
      image: getRandomImage(),
      name: "Building Construction",
      description: "We specialize in comprehensive building construction services, from residential to commercial projects. Our team ensures quality and efficiency at every stage.",
      stats: {
        projectsCompleted: 250,
        clientSatisfaction: 95,
        workforce: 1200
      }
    },
    {
      id: 2,
      image: getRandomImage(),
      name: "Road Construction",
      description: "Our road construction services include the design and building of highways, streets, and bridges, ensuring durability and safety for all users.",
      stats: {
        projectsCompleted: 150,
        clientSatisfaction: 92,
        workforce: 800
      }
    },
    {
      id: 3,
      image: getRandomImage(),
      name: "Infrastructure Development",
      description: "We focus on large-scale infrastructure projects that enhance connectivity and support economic growth, including airports, railways, and utilities.",
      stats: {
        projectsCompleted: 100,
        clientSatisfaction: 90,
        workforce: 500
      }
    },
    {
      id: 4,
      image: getRandomImage(),
      name: "Renovation & Remodeling",
      description: "Our renovation services transform existing spaces into modern, functional environments while preserving their unique character.",
      stats: {
        projectsCompleted: 300,
        clientSatisfaction: 98,
        workforce: 600
      }
    },
    {
      id: 5,
      image: getRandomImage(),
      name: "Logistics",
      description: "A service that streamlines supply chain operations, featuring advanced warehousing and distribution facilities",
      stats: {
        projectsCompleted: 900,
        clientSatisfaction: 94,
        workforce: 500
      }
    }
    
  ]

  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(servicesData)
    }, 2000)
  });
};



const Services = () => {

  // SET THE PAGE LOADING TIMER
  const [services, setServices] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    Aos.init({ duration: 1000, once: true });

    const getServiceData = async () => {
      setIsLoading(true);

      const data = await fetchServiceData();
      setServices(data);
      setIsLoading(false);
    };

    getServiceData();
  }, []);



  return (
    <>
      <Header />
      <br/><br/><br/>

      {/* RANDOM SERVICES DATA */}
      <section className='bg-gradient-to-r from-gray-700 to-[#29313f] text-white py-16'>
        <div className='container mx-auto text-center px-6'>
          <h2
            className='text-3xl sm:text-4xl font-semibold mb-8'
            data-aos="fade-up"
          >
            Our Services
          </h2>

          {isLoading ? (
            <Loader />
          ) : (
            <div className='grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-12'>
              {/* FETCCH SERVICES DATA ARRAY FROM USESTATE */}
              {services.map((service) => {
                return (
                  <div
                    key={service.id}
                    className="flex flex-col items-center text-center p-6 bg-slate-100 rounded-lg shadow-lg hover:scale-105 transform transition-all"
                  >
                    <img
                      src={service.image}
                      alt={service.name}
                      className='w-full h-56 object-cover rounded-lg mb-4'
                      onError={(e) => (e.target.src = 'https://via.placeholder.com/600x400?text=Image+Not+Available')}
                    />
                    <h3 className="text-2xl font-semibold text-gray-800">
                      {service.name}
                    </h3>
                    <p className='text-gray-600 mt-2'>
                      {service.description}
                    </p>
                  </div>
                )
              })}
            </div>
          )}
        </div>

      </section>

      {/* PROJECTS STATISTICS */}
      <section className='py-16 bg-gray-200'>
        <div className='container mx-auto text-center px-6'>
          <h2
            className='text-3xl sm:text-4xl font-semibold text-gray-900 mb-8'
            data-aos="fade-up"
          >
            Achievements
          </h2>

          {isLoading ? (
            <Loader />
          ) : (
            <div className='grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-12'>
              {services.map((service) => {
                return (
                  <div
                    key={service.id}
                    className="bg-white p-6 rounded-lg shadow-lg hover:scale-105 transition-transform hover:shadow-xl"
                  >
                    <h3 className='text-xl font-semibold mb-4'>
                      {service.name}
                    </h3>

                    <div className='space-y-4'>
                      <div className='flex justify-between'>
                        <span className='font-medium'>
                          Projects Completed
                        </span>
                        <span className='text-gray-600'>
                          {service.stats.projectsCompleted}+
                        </span>
                      </div>

                      <div className='flex justify-between'>
                        <span className='font-medium'>
                          Client Satisfaction
                        </span>
                        <span className='text-gray-600'>
                          {service.stats.clientSatisfaction}%
                        </span>
                      </div>

                      <div className='flex justify-between'>
                        <span className='font-medium'>
                          Workforce
                        </span>
                        <span className='text-gray-600'>
                          {service.stats.workforce}+
                        </span>
                      </div>
                    </div>

                    <div className='mt-4'>
                      <div className='flex items-center justify-between'>
                        <span className='text-sm font-medium'>
                          Client Satisfaction
                        </span>
                        <span className='text-sm font-semibold'>
                          {service.stats.clientSatisfaction}%
                        </span>
                      </div>

                      <div className='w-full bg-gray-200 h-2 mt-2 rounded-full'>
                        <div
                          className='bg-[#29313f] h-2 rounded-full'
                          style={{ width: `${service.stats.clientSatisfaction}%` }}
                        >
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          )}
        </div>
      </section>

      {/* COMMODITIES SECTION */}
      <Commodities />

      <Footer />
    </>
  )
}

export default Services